import React, { useCallback } from 'react'
import { makeStyles } from '@material-ui/core'
import { Button } from '@material-ui/core'
import { FONT_WEIGHTS } from '../../../utils'

const useStyles = makeStyles(() => ({
	root: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		width: '100%',
		alignItems: 'center',
		gap: '1rem'
	},
	mainText: { fontFamily: 'Nunito', fontSize: '1.5rem', fontWeight: FONT_WEIGHTS.SemiBold, textAlign: 'center' },
	secondaryText: {
		fontFamily: 'Nunito',
		fontSize: '1rem',
		fontWeight: FONT_WEIGHTS.SemiBold,
		textAlign: 'center',
		marginBottom: '1rem',
		padding: '0 13rem'
	},
	imageContainer: {
		height: '8.625rem',
		display: 'flex',
		alignContent: 'center',
		justifyContent: 'center',
		marginBottom: '1rem'
	},
	image: { objectFit: 'contain' }
}))

const CallToActionView = ({
	mainText = '',
	secondaryText = '',
	imageSrc = '',
	actionTitle,
	onAction,
	secondaryActionTitle,
	onSecondaryAction
}) => {
	const classes = useStyles()
	const handleOnAction = useCallback(() => {
		if (onAction) {
			onAction()
		}
	}, [onAction])
	const handleOnSecondaryAction = useCallback(() => {
		if (onSecondaryAction) {
			onSecondaryAction()
		}
	}, [onSecondaryAction])
	return (
		<div className={classes.root}>
			<div style={{ flex: 1 }} />
			<div className={classes.imageContainer}>
				<img className={classes.image} src={imageSrc} />
			</div>
			<div className={classes.mainText}>{mainText}</div>
			<div className={classes.secondaryText}>{secondaryText}</div>
			{onAction ? (
				<Button disableElevation variant="contained" color="secondary" onClick={handleOnAction}>
					{actionTitle}
				</Button>
			) : null}
			{onSecondaryAction && secondaryActionTitle > '' ? (
				<Button disableElevation variant="outlined" color="secondary" onClick={handleOnSecondaryAction}>
					{secondaryActionTitle}
				</Button>
			) : null}
			<div style={{ flex: 1 }} />
		</div>
	)
}

export default CallToActionView
